import { accessibility } from './modules/accessibility'
import { arrangements } from './modules/arrangements'
import { cardsCarousel } from './modules/cardsCarousel'
import { infoContentOffset } from './modules/infoContentOffset'
import { servicesScroll } from './modules/servicesScroll'
import { bannerForms } from './modules/bannerForms'
import { cardLink } from './modules/cardLink'
import { contactBubble } from './modules/contactBubble'
import { counter } from './modules/counter'
import { devicecheck } from './modules/devicecheck'
import { dialog } from './modules/dialog'
import { facts } from './modules/facts'
import { fileSize } from './modules/fileSize'
import { fileUploadHint } from './modules/fileUploadHint'
import { iframeHeightCalc } from './modules/iframeHeightCalc'
import { lexikon } from './modules/lexikon'
import { lightbox } from './modules/lightbox'
import { nav } from './modules/nav'
import { onScroll } from './modules/onScroll'
import { openFilter } from './modules/openFilter'
import { popups } from './modules/popups'
import { preload } from './modules/preload'
import { propertiesMap } from './modules/propertiesMap'
import { rooms } from './modules/rooms'
import { scrollCounter } from './modules/scrollCounter'
import { slider } from './modules/slider'
import { toggleItem } from './modules/toggleItem'

window.onload = function () {
	slider()
	onScroll()
	preload()
	nav()
	openFilter()
	lightbox()
	counter()
	dialog()
	toggleItem()
	facts()
	bannerForms()
	accessibility()
	iframeHeightCalc()
	devicecheck()
	popups()
	rooms()
	arrangements()
	cardsCarousel()
	infoContentOffset()
	servicesScroll()
	lexikon()
}

// runs before window.onload (which waits for images) to avoid a flash of
// the resting state before the scroll position is applied
scrollCounter()

// runs independently of window.onload so an unrelated error in another
// module can't prevent the card click handlers from being attached
cardLink()
contactBubble()
fileSize()
fileUploadHint()
// must run before the layout's own 'load' listener checks googleMapScripts.length,
// otherwise the Google Maps API script never gets requested
propertiesMap()
